/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople200,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople400,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople401,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople500,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeopleQueryParams,
  GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeopleQueryResponse,
} from "../../types/courseRegistrationAssociatedCompanyDocumentApprovalController/GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople.ts";
import { associatedCompanyDocumentApprovalListItemViewModelPaginatedResponseSchema } from "../associatedCompanyDocumentApprovalListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeopleQueryParamsSchema =
  z.object({
    ClassStudents: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "IDs das turmas. Opcional (ao menos um filtro é obrigatório).",
        ),
    ),
    PersonId: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "ID do aluno; quando informado, os filtros de status não se aplicam (comportamento do legado). Opcional.",
        ),
    ),
    EnrollmentStatus: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "Status da matrícula para filtro. Opcional. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
        ),
    ),
    DocumentationStatus: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "Status geral da documentação da conveniada para filtro. Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
        ),
    ),
    AssociatedCompanyId: z.optional(
      z.coerce.number().int().describe("ID da empresa conveniada. Opcional."),
    ),
    Page: z.coerce
      .number()
      .int()
      .default(1)
      .describe("Página da listagem (10 itens por página). Mínimo 1."),
  }) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeopleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople200Schema =
  z.lazy(
    () =>
      associatedCompanyDocumentApprovalListItemViewModelPaginatedResponseSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople500>;

export const getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeopleQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeople200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationAssociatedCompanyDocumentApprovalPeopleQueryResponse>;
